module.exports = __webpack_public_path__ + "static/media/Vector.45fee791.svg";